import React from 'react';
import { Line } from 'react-konva';

export const GridLines = ({ width, height, gridSize = 50, show }) => {
  if (!show) return null;
  
  const lines = [];
  
  for (let i = gridSize; i < width; i += gridSize) {
    lines.push(
      <Line key={`v-${i}`} points={[i, 0, i, height]} stroke="#E0E0E0" strokeWidth={0.5} listening={false} />
    );
  }
  
  for (let i = gridSize; i < height; i += gridSize) {
    lines.push(
      <Line key={`h-${i}`} points={[0, i, width, i]} stroke="#E0E0E0" strokeWidth={0.5} listening={false} />
    );
  }
  
  return <>{lines}</>;
};
